import { ToastOptions } from 'react-toastify'

export const toastStyle = {
  position: 'top-center',
  autoClose: 4000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  containerId: 'system',
} as ToastOptions

export const toastStyleTopRight = {
  ...toastStyle,
} as ToastOptions
